const TermsOfService = () => {
  return (
    <div className="policy-container">
      <h1>Terms of Service</h1>

      <p>
        Welcome to The Karigar Stop! These Terms of Service ("Terms") govern your use of our website, platform, and services.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using The Karigar Stop services, you agree to be bound by these Terms and our <a href="/privacy-policy">Privacy Policy</a>.
      </p>

      <h2>2. Services</h2>
      <p>
        We provide residential concierge and home services via our platform. We do not guarantee availability or results of services.
      </p>

      <h2>3. User Responsibilities</h2>
      <p>
        You agree to use the platform responsibly, provide accurate information, and respect our policies and community guidelines.
      </p>

      <h2>4. Payments, Refunds & Cancellations</h2>
      <p>
        Payments made through our platform are subject to applicable terms. Refunds and cancellations will follow our <a href="/refund-cancellation-policy" style={{ color: "#5B2A93", fontWeight: 600 }}>Refund & Cancellation Policy</a>.
      </p>

      <h3>Payment Terms for Events</h3>
      <ul>
        <li>For any event booking, an <strong>advance payment of 80%</strong> of the total amount is required at the time of booking. This is necessary to secure the vendors and services.</li>
        <li>For <strong>one-day events</strong>, the remaining <strong>10% payment is due on the event day</strong>.</li>
        <li>For <strong>multi-day or long-duration events</strong>, <strong>10% payment is due on each event day</strong> as agreed.</li>
        <li>The <strong>final 10% payment is due after the event completion</strong>.</li>
        <li>Payments must be made as per the schedule to avoid any disruptions in service.</li>
      </ul>
      <p>
        Please refer to our <a href="/refund-cancellation-policy" style={{ color: "#5B2A93", fontWeight: 600 }}>Refund & Cancellation Policy</a> for details regarding eligibility, process, and timelines for cancellations and refunds, including for same-day or on-demand services.
      </p>

      <h2>5. Intellectual Property</h2>
      <p>
        All content, logos, and trademarks on The Karigar Stop are our property or licensed to us. Unauthorized use is prohibited.
      </p>

      <h2>6. Limitation of Liability</h2>
      <p>
        We are not liable for any damages resulting from use or inability to use our services.
      </p>

      <h2>7. Changes to Terms</h2>
      <p>
        We may update these Terms from time to time. Continued use constitutes acceptance of changes.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        If you have any questions about these Terms, please contact us at <a href="mailto:thekarigarstop@gmail.com">thekarigarstop@gmail.com</a>.
      </p>

      <p>Last updated: July 2025</p>

      {/* Footer-style links for visibility */}
      <div
        style={{
          marginTop: "2.5rem",
          padding: "1.2rem 0",
          background: "#f6f1ff",
          textAlign: "center",
          color: "#5B2A93",
          borderRadius: 10,
          fontWeight: 500,
          fontSize: "1rem"
        }}
      >
        <span style={{ margin: "0 10px" }}>
          <a href="/terms-of-service" style={{ color: "#5B2A93" }}>Terms of Service</a>
        </span>
        |
        <span style={{ margin: "0 10px" }}>
          <a href="/privacy-policy" style={{ color: "#5B2A93" }}>Privacy Policy</a>
        </span>
        |
        <span style={{ margin: "0 10px" }}>
          <a href="/refund-cancellation-policy" style={{ color: "#5B2A93" }}>Refund & Cancellation Policy</a>
        </span>
        <br />
        <span style={{ color: "#888", fontSize: "0.85rem", fontWeight: 400 }}>
          &copy; {new Date().getFullYear()} THE KARIGAR STOP. All rights reserved.
        </span>
      </div>
    </div>
  );
};

export default TermsOfService;
